
  import React, { useState, useEffect } from 'react';
  import './App.css';
  import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate, useLocation, useParams } from "react-router-dom";
  import { useSelector } from 'react-redux';
  import store from './store';
  import Home from './components/Home';
  import Home2 from './components/Home2';
  import Home3 from './components/Home3';
  import NewYear from './components/NewYear';
  import Navbar from './components/Navbar';
  import MyNotes from './components/UserPortal/MyNotes';
  import DashBoard from './components/UserPortal/DashBoard';
  import NoteDetails from './components/UserPortal/NoteDetails';
import NodeAnalysis from './components/UserPortal/NodeAnalysis';
  import Account from './components/UserPortal/Account';
  import Referral from './components/UserPortal/Referral';
  import NewNote from './components/UserPortal/NewNote';
  import Signup from './components/Signup';
  import Subscribe from './components/UserPortal/Subscribe';
  import { loadUser } from './actions/userAction';
  import ProtectedRoute from './components/Route/ProtectedRoute';
  import PublicRoute from './components/Route/PublicRoute';
  import Checkout from './components/UserPortal/Checkout';
  import CheckoutSuccess from './components/UserPortal/CheckoutSuccess';
  import ExploreComingSoon from './components/UserPortal/ExploreComingSoon';
  import ExploreFeed from './components/UserPortal/ExploreFeed';
  import Saved from './components/UserPortal/Saved';
  import PublicSearch from './components/PublicSearch';
  import Congrats from './components/UserPortal/Congrats';
  import Privacy from './components/Privacy';
import Terms from './components/Terms';
import CookiePolicy from './components/CookiePolicy';
import About from './components/About';
import IntentArchive from './components/IntentArchive';
import Founder from './components/Founder';
import Admin from './components/Admin/Admin';
import Stats from './components/Admin/Stats';
import Prices from './components/Admin/Prices';
import Reset from './components/Utility/Reset';
import ResetPassword from './components/Utility/ResetPassword';
import Error from './components/Utility/Error';
import Building from './components/Utility/Building';
import Contact from './components/Contact';
import Pricing from './components/Pricing';
import { Helmet } from 'react-helmet';
import RefundPolicy from './components/RefundPolicy';
import Loader from './layout/Loder';
import PaymentHistory from './components/UserPortal/PaymentHistory';
import LiveCount from './components/LiveCount';
import FloatingFlag from './components/FloatingFlag';
import CreateYearPlan from './components/UserPortal/CreateYearPlan';
import VisionStartFlow from './components/UserPortal/VisionStartFlow';
import VisionStartNode from './components/UserPortal/VisionStartNode';
import VisionExpand from './components/UserPortal/VisionExpand';
import VisionBootSequence from './components/UserPortal/VisionBootSequence';
import YearPlanView from './components/UserPortal/YearPlanView';
import CreatePage from './components/UserPortal/CreatePage';
import PlanTransition from './components/UserPortal/PlanTransition';
import Blog from './components/Blogs/Blog';
import BlogPost from './components/Blogs/BlogPost';
import SideQuest from './components/UserPortal/SideQuest';
import PlanCosmosView from './components/UserPortal/PlanCosmosView';
import PlanAnalysis from './components/UserPortal/PlanAnalysis';
import VisionTodos from './components/UserPortal/VisionTodos';
import Drafts from './components/UserPortal/Drafts';
import AdminDrafts from './components/Admin/AdminDrafts';
import AdminMarketing from './components/Admin/AdminMarketing';
import UnsubscribeDraft from './components/Utility/UnsubscribeDraft';
import UnsubscribeMarketing from './components/Utility/UnsubscribeMarketing';
import CookieBanner from './components/CookieBanner';
import ProjectFive from './components/ProjectFive';
import NotificationStrip from './components/NotificationStrip';
import AdminNotifications from './components/Admin/AdminNotifications';
import AdminRetention from './components/Admin/AdminRetention';
import AdminCampaigns from './components/Admin/AdminCampaigns';
import IntroStory from './components/IntroStory';
import PlanningHome from './components/Planning/PlanningHome';
import PlanningOnboard from './components/Planning/PlanningOnboard';
import PlanningWorkspace from './components/Planning/PlanningWorkspace';
import PlanningDocEditor from './components/Planning/PlanningDocEditor';
import FocusWidget from './components/FocusWidget';


  const PENDING_KEY = "dmyor_vision_pending";
  const PENDING_PLAN_KEY = "dmyor_planning_pending";
  const POST_AUTH_REDIRECT_KEY = "dmyor_post_auth_redirect";

  function PendingVisionGuard() {
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated } = useSelector((state) => state.user || {});

    useEffect(() => {
      if (!isAuthenticated) return;
      const postAuthRedirect = localStorage.getItem(POST_AUTH_REDIRECT_KEY);
      if (postAuthRedirect) {
        localStorage.removeItem(POST_AUTH_REDIRECT_KEY);
        navigate(postAuthRedirect, { replace: true });
      }
    }, [isAuthenticated, navigate]);

    return null;
  }

  // After login/signup, if user had a pending plan draft, resume it.
  function PendingPlanResumeRoute() {
    const navigate = useNavigate();
    const { isAuthenticated } = useSelector((state) => state.user || {});
    const [done, setDone] = useState(false);

    useEffect(() => {
      if (!isAuthenticated || done) return;
      setDone(true);
      try {
        const raw = localStorage.getItem(PENDING_PLAN_KEY);
        if (raw) {
          navigate('/dashboard/planning/new', { replace: true, state: { pendingDraft: JSON.parse(raw) } });
          return;
        }
      } catch (_) {}
      navigate('/dashboard/planning/new', { replace: true });
    }, [isAuthenticated, done, navigate]);

    if (!isAuthenticated) return <Navigate to="/login" replace />;
    return <div style={{ padding: '2rem', color: '#999' }}>Loading…</div>;
  }

  function RedirectPlanningVision() {
    const { visionId } = useParams();
    return <Navigate to={`/dashboard/planning/${visionId}`} replace />;
  }

  // Suppress unhandled promise rejections from network errors so the dev overlay never fires.
  if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (e) => {
      if (e.reason?.isAxiosError || e.reason?.name === 'AxiosError') e.preventDefault();
    });
  }

  function App() {
    const [isCreatePostModalOpen, setIsCreatePostModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const dispatchUser = async() => {
     await store.dispatch(loadUser());
     setIsLoading(false);
    }
    useEffect(() => {
      dispatchUser();
    }, []);

    const handleCreateClick = () => {
      setIsCreatePostModalOpen(true);
    };

    window.addEventListener("contextmenu", (e) => e.preventDefault());
    return (
      <div className="App">
         <Helmet>
  <title>dmyor — Make It Real</title>
  <meta name="description" content="dmyor is where you plan the next chapter of your life, write your intentions across every category, and document your way to making it real." />
  <meta property="og:title" content="dmyor — Make It Real" />
  <meta property="og:description" content="dmyor is where you plan the next chapter of your life, write your intentions across every category, and document your way to making it real." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://dmyor.com" />
  <meta property="og:image" content="https://dmyor.com/images/og-image.png" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="dmyor — Make It Real" />
  <meta name="twitter:description" content="dmyor is where you plan the next chapter of your life, write your intentions across every category, and document your way to making it real." />
  <meta name="twitter:image" content="https://dmyor.com/images/og-image.png" />
</Helmet>

      <NotificationStrip />
      <CookieBanner />
      {isLoading? <Loader/> :(
        <Router>
        {/* <Routes>
      </Routes> */}
        <PendingVisionGuard />
        <FocusWidget />
        <Routes>
        <Route path="intro" element={<IntroStory />} />
        <Route element={<PublicRoute/>}>
  <Route path="/" element={<Navbar/>}>

    <Route index element={<Navigate to="/home" replace />} />

    {/* Home (new marketing page) */}
    <Route path="home" element={<Home2 />} />
    {/* OLD home variants — deprecated */}
    {/* <Route path="home2" element={<Home />} /> */}
    {/* <Route path="home3" element={<Home3 />} /> */}
    {/* OLD vision creation / view (replaced by planning) */}
    {/* <Route path="start" element={<VisionStartFlow />} /> */}
    <Route path="start" element={<Navigate to="/dashboard/planning/new" replace />} />

    <Route path="about" element={<About/>} />
    <Route path="pricing" element={<Pricing/>} />
    <Route path="intent-archive" element={<IntentArchive/>} />
    <Route path="founder" element={<Founder/>} />
    <Route path="signup" element={<Signup/>} />
    <Route path="login" element={<Signup/>} />
    <Route path="s" element={<ExploreFeed/>}/>
    <Route path="s/:id" element={<PublicSearch/>}/>
    <Route path="contact" element={<Contact/>}/>
    <Route path="blog" element={<Blog/>} />
    <Route path="blog/:slug" element={<BlogPost/>} />
    <Route path="2026" element={<NewYear/>} />
    <Route path="project-5" element={<ProjectFive/>} />
    {/* OLD vision view — deprecated */}
    {/* <Route path="vision/:id" element={<YearPlanView/>} /> */}
        {/* <Route path="/pricing"  element = {<Pricing />}/>   */}
        </Route>
        </Route>
        <Route element = {<ProtectedRoute/>} >
        <Route  path =  "/dashboard" element = {<DashBoard onCreateClick={handleCreateClick} />} >
          {/* My space is now the planning workspace */}
          <Route index element = {<Navigate to="/dashboard/planning" replace />}/>
          {/* ── OLD MY SPACE / VISIONS (deprecated) ── */}
          {/* <Route path = 'mynotes' element = {<MyNotes/>}/> */}
          {/* <Route path = 'note-details/:id' element = {<NoteDetails/>} /> */}
          {/* <Route path = 'note-details/:id/analysis' element = {<NodeAnalysis/>} /> */}
          {/* <Route path="side-quest/new" element={<SideQuest />} /> */}
          {/* <Route path="side-quest/:planId/new" element={<SideQuest />} /> */}
          {/* <Route path="plan-cosmos/:planId" element={<PlanCosmosView />} /> */}
          {/* <Route path="/dashboard/plan-transition" element={<PlanTransition />} /> */}
          {/* <Route path="year-plan/:planId/new" element={<NewNote />} /> */}
          {/* <Route path="counter" element = {<LiveCount/>}/> */}
          {/* <Route path="year-plans" element={<Navigate to="/dashboard/start" replace />} /> */}
          {/* <Route path="year-plans/legacy" element={<CreateYearPlan />} /> */}
          {/* <Route path="start" element={<VisionStartFlow guestMode={false} />} /> */}
          {/* <Route path="start/node/:planId/:id" element={<VisionStartNode />} /> */}
          {/* <Route path="start/vision-setup/:planId" element={<VisionExpand />} /> */}
          {/* <Route path = 'congratulations/:id' element = {<Congrats/>}/> */}
          {/* <Route path="year-plan/:id" element={<YearPlanView />} /> */}
          {/* <Route path="year-plan/:id/analysis" element={<PlanAnalysis />} /> */}
          {/* <Route path="year-plan/:id/todos" element={<VisionTodos />} /> */}

          {/* ── Kept ── */}
          <Route path = 'account' element = {<Account/>}/>
          <Route path = 'refer' element = {<Referral/>}/>
          <Route path = 'upgrade' element = {<Subscribe/>}/>
          <Route path= 'create' element = {<CreatePage/>}/>
          <Route path= 'drafts' element = {<Drafts/>}/>
          <Route path= 'new' element = {<NewNote/>}/>
          {/* Explore = public planning-vision feed; Saved = bookmarked visions */}
          <Route path="search" element = {<ExploreFeed/>}/>
          <Route path="saved" element = {<Saved/>}/>
          <Route path = 'payment-history' element = {<PaymentHistory/>}/>
          {/* Vision boot sequence — reused by the planning create flow */}
          <Route path="start/booting" element={<VisionBootSequence />} />
          {/* New visions (planning) */}
          <Route path="planning" element={<PlanningHome />} />
          <Route path="planning/new/resume" element={<PendingPlanResumeRoute />} />
          <Route path="planning/:visionId" element={<PlanningWorkspace />} />
          <Route path="planning/:visionId/doc/:resourceId" element={<PlanningDocEditor />} />
        </Route>
        <Route path='/admin' element={<Admin isAdmin={true}/>} >
          <Route index element={<Stats/>}/>
          <Route path='prices' element = {<Prices/>} />
          <Route path="search" element = {<ExploreComingSoon/>}/>
          <Route path='drafts' element={<AdminDrafts/>}/>
          <Route path='marketing' element={<AdminMarketing/>}/>
          <Route path='notifications' element={<AdminNotifications/>}/>
          <Route path='retention' element={<AdminRetention/>}/>
          <Route path='campaigns' element={<AdminCampaigns/>}/>
        </Route>
        <Route path = "/checkout" element = {<Checkout/>} />
        <Route path= '/checkout-success' element = {<CheckoutSuccess/>}/>
        <Route path='/planning' element={<Navigate to="/dashboard/planning" replace />} />
        <Route path='/planning/new' element={<PlanningOnboard />} />
        <Route path='/planning/:visionId' element={<RedirectPlanningVision />} />
        </Route>
        {/* planning/new is public — guests can create before logging in */}
        <Route path='/dashboard/planning/new' element={<PlanningOnboard />} />
        {/* <Route element={<ProtectedRoute isAdmin={true}/>}>
            <Route path='/admin' element={<Admin/>} >

            </Route>
        </Route> */}
        {/* <Route path='/s/:id' element = {<PublicSearch/>}/> */}
        <Route path='/unsubscribe-drafts' element={<UnsubscribeDraft/>}/>
        <Route path='/unsubscribe' element={<UnsubscribeMarketing/>}/>
        <Route path='/error' element = {<Error/>}/>
        <Route path='/building' element = {<Building/>}/>
        <Route path="*" element={<Navigate to="/" />} />
        <Route path="/privacy-policy"  element = {<Privacy />}/>  
        <Route path="/terms"  element = {<Terms />}/>
        <Route path="/cookie-policy"  element = {<CookiePolicy />}/>
        <Route path="/refund-policy"  element = {<RefundPolicy />}/>          
        <Route path="/password-reset"  element = {<Reset />}/>  
        <Route path="/resetpassword/:token"  element = {<ResetPassword />}/>  
        </Routes>
      </Router>  
      )}
      
      </div>
    );
  }

  export default App;
